import locales from './locales'

export default Object.keys(locales).reduce((catalogs, locale) => {
  return {
    ...catalogs,
    [locale]: locales[locale].catalog,
  }
}, {})
